import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import * as Connection from "./../libs/connections";
import $ from "jquery";
import _ from "lodash";
import { upperCase } from "lodash";

import Preloader from "./../components/global/Preloader";
import HeroBannerCar from "./../components/HeroBannerCar";
import PhotoGallery from "./../components/PhotoGallery";
import OurCars from "./../components/OurCars";
import SectionImageText from "./../components/SectionImageText";
import SectionHistory from "./../components/SectionHistory";
import SectionBenefits from "./../components/SectionBenefits";
import SectionOfferContent from "./../components/SectionOfferContent";
import SeparatorText from "./../components/SeparatorText";
import Calculator from "./../components/calculator";
import ModalCarContactWrapper from "../components/ModalContact/ModalCarContactWrapper";

import { ThemeContext } from "./../containers/ThemeContext";

import "../styles/sites/CarPage.css";
import "../styles/components/SectionCarText.css";
import EmptyCalculator from "../components/calculator/EmptyCalculator";

class CarPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carData: undefined,
      pageTitle: "",
      calculator: {},
      loading: true,
      error: false,
      activeTab: "Historia",
      originalBasePrice: "",
      ofertaTop: 0,
      korzysciTop: 0,
      historiaTop: 0,
      showModal: false
    };
    this.scrollTo = this.scrollTo.bind(this);
  }

  scrollTo(element) {
    const elementId = upperCase(element);
    if (!!$(`#${elementId}`)[0]) {
      $("html, body").animate(
        { scrollTop: $(`#${elementId}`).offset().top },
        1000
      );
      this.setState({
        activeTab: elementId
      });
    }
  }

  manageSectionSubMenu = async () => {
    try {
      const elemCarPageFloatingMenu = $(".carPageFloatingMenu");
      const elemCarPageFloatingMenuItem = $(".carPageFloatingMenu li");
      let carPageFloatingMenuFromTop = elemCarPageFloatingMenu.offset().top / 2;
      let sections = null;

      function activateMenuItem(name) {
        if (name !== null) {
          elemCarPageFloatingMenuItem.each(function(idx, elem) {
            if (
              $(this)
                .find("span")
                .text() === name
            ) {
              $(this).addClass("active");
            } else {
              $(this).removeClass("active");
            }
          });
        } else {
          elemCarPageFloatingMenuItem.each(function(idx, elem) {
            $(this).removeClass("active");
          });
        }
      }

      function activateMenuPosition(scrolled) {
        if (scrolled) {
          if (!elemCarPageFloatingMenu.hasClass("active")) {
            elemCarPageFloatingMenu.addClass("active");
          }
        } else {
          if (elemCarPageFloatingMenu.hasClass("active")) {
            elemCarPageFloatingMenu.removeClass("active");
          }
        }
      }

      function getSectionsToMenu() {
        sections = [];
        $(".separator-text").each(function(idx, elem) {
          sections.push({
            name: $(this).attr("id"),
            from: $(this).offset().top - $(window).height() / 3
          });
        });
      }

      getSectionsToMenu();

      $(window).resize(function() {
        if ($(".page-car").length !== 0) {
          carPageFloatingMenuFromTop = elemCarPageFloatingMenu.offset().top / 2;
        }
      });

      $(window).scroll(function() {
        if ($(".page-car").length !== 0) {
          const heightFromTop = $(this).scrollTop();
          let activeElementIdx = null;
          sections.forEach((item, idx) => {
            if (heightFromTop > item.from) {
              activeElementIdx = item.name;
            }
          });
          activateMenuItem(activeElementIdx);
          if (heightFromTop > carPageFloatingMenuFromTop) {
            activateMenuPosition(true);
          } else {
            activateMenuPosition(false);
          }
        }
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  };

  async getPageData(carId) {
    this.setState({
      loading: true
    });
    try {
      const response = await Connection.getSingleCar(carId);
      this.setState({
        loading: false,
        carDataBase: response[0],
        carData: response[0].acf,
        carId: response[0].id,
        carCategory: response[0].categories[0],
        carManufacture: response[0].title.rendered.split(" ")[0],
        pageTitle: response[0].title.rendered
          .split(" ")
          .slice(1)
          .join(" "),
        originalBasePrice: response[0].acf.prices.originalBasePrice
      });
      $(document).ready(() => {
        this.manageSectionSubMenu();
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      const pathSplit = nextProps.location.pathname.split("/");
      this.getPageData(pathSplit[pathSplit.length - 1]);
    }
  }

  componentDidMount() {
    this.getPageData(this.props.match.params.id);
  }

  render() {
    const availableNow = _.get(this.state, "carData.availableNow", {});

    if (this.state.error) {
      return <Redirect to="/error" />;
    } else if (!this.state.carData) {
      return (
        <div className="page-car scroll" style={{ overflow: "hidden" }}>
          <Preloader global loading={this.state.loading} />
        </div>
      );
    } else if (this.state.carData) {
      const shouldDisplayCalculator =
        this.state.carData.leasing || this.state.carData.rentLong;

      return (
        <div className="page-car scroll" style={{ overflow: "hidden" }}>
          <HeroBannerCar
            availableNow={availableNow}
            backgroundImage={this.state.carData.vehiclePhotoWidescreen}
            headerText={this.state.pageTitle}
            carManufacture={this.state.carManufacture}
            carData={this.state.carData.parameters}
            rentFromPriceValue={
              this.state.carData.prices.rentFromPrice.rentFromPriceValue
            }
          />
          <div className="navigation-buttons">
            <div className="container">
              <div className="row">
                <div className="col-6">
                  <Link
                    className="btn-general btn-general--secondary btn-general--icon-left"
                    to="/flota"
                  >
                    Wróć
                  </Link>
                </div>
                <div className="col-6 text-right">
                  <Link
                    className="btn-general btn-general--primary"
                    to="/kontakt"
                  >
                    Kontakt
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {this.state.carData.vehiclePhotoGallery && (
            <PhotoGallery photoList={this.state.carData.vehiclePhotoGallery} />
          )}
          {this.state.carData.history && (
            <React.Fragment>
              <SeparatorText
                alignToRight={true}
                paddingTop={250}
                paddingBottom={250}
                text={this.state.carData.history.groupTitle}
              />
              <SectionHistory data={this.state.carData.history} />
            </React.Fragment>
          )}
          {this.state.carData.vehicleIntroduction && (
            <>
              <SeparatorText
                alignToRight={true}
                paddingTop={100}
                paddingBottom={100}
                text={_.get(
                  this.state,
                  "carData.vehicleIntroduction[0].titleSection",
                  "Pojazd"
                )}
              />
              <SectionOfferContent
                data={{
                  contentSingle: this.state.carData.vehicleIntroduction
                }}
                type="cars"
              />
            </>
          )}
          <SeparatorText
            paddingTop={150}
            paddingBottom={50}
            text={this.state.carData.vehicleBenefitsTitle}
          />
          <SectionBenefits
            data={this.state.carData.vehicleBenefits}
            dataButton={this.state.carData.vehicleBenefitsLink}
          />
          <SectionImageText
            text={this.state.carData["section-text-photo-value"]}
            wrapperClasses={`container`}
            paddingTop={290}
            paddingBottom={100}
            backgroundImage={
              this.state.carData["section-text-photo-url"]["url"]
            }
          />
          <SeparatorText
            alignToRight={true}
            paddingTop={100}
            paddingBottom={150}
            text={this.state.carData.vehicleOfferTitle}
          />
          {!shouldDisplayCalculator && (
            <EmptyCalculator
              carData={this.state.carDataBase}
              showModal={this.context.showModalContact}
              // showModal={() => {
              //   this.setState({
              //     showModal: true
              //   });
              // }}
            />
          )}
          {shouldDisplayCalculator && (
            <Calculator
              showModal={() => {
                this.setState({
                  showModal: true
                });
              }}
              saveCalcData={data => {
                this.setState({
                  calculator: data
                });
              }}
              calcType={this.state.carData.calcType}
              rentLong={this.state.carData.rentLong}
              leasing={this.state.carData.leasing}
              carData={this.state.carDataBase}
            />
          )}
          {/* <SectionContactCarRent
            leftColumn={this.state.carData}
            sellPrice={this.state.carData.prices.sellPrice}
            originalBasePrice={this.state.originalBasePrice}
            prices={this.state.carData.prices}
            title={this.state.pageTitle}
          /> */}
          {this.state.carData.vehicleMotoconcierge && (
            <>
              <SeparatorText
                paddingTop={200}
                paddingBottom={100}
                text={_.get(
                  this.state,
                  "carData.vehicleMotoconcierge[0].title",
                  ""
                )}
              />
              <SectionOfferContent
                data={{
                  contentSingle: _.get(
                    this.state,
                    "carData.vehicleMotoconcierge",
                    {}
                  )
                }}
                type="cars"
              />
            </>
          )}

          {this.state.carCategory && (
            <OurCars
              background
              hideButton
              carId={this.state.carId}
              carCategory={this.state.carCategory}
              paddingTop={50}
              paddingBottom={80}
              text="Podobne pojazdy"
              sectionNumber={"01."}
            />
          )}
          <div className="carPageFloatingMenu">
            <ul>
              {this.state.carData.history && (
                <li className={`carPageFloatingMenu__item menu-history`}>
                  <span onClick={() => this.scrollTo("Historia")}>
                    Historia
                  </span>
                </li>
              )}
              {this.state.carData.vehicleIntroduction && (
                <li className={`carPageFloatingMenu__item menu-benefits`}>
                  <span onClick={() => this.scrollTo("Pojazd")}>Pojazd</span>
                </li>
              )}
              <li className={`carPageFloatingMenu__item menu-benefits`}>
                <span onClick={() => this.scrollTo("Korzyści")}>Korzyści</span>
              </li>
              <li className={`carPageFloatingMenu__item menu-offer`}>
                <span onClick={() => this.scrollTo("Oferta")}>Oferta</span>
              </li>
              {this.state.carData.vehicleMotoconcierge && (
                <li className={`carPageFloatingMenu__item menu-offer`}>
                  <span onClick={() => this.scrollTo("MOTOCONCIERGE")}>
                    MOTOCONCIERGE
                  </span>
                </li>
              )}
            </ul>
          </div>
          {this.state.showModal && (
            <ModalCarContactWrapper
              hideModalContact={() => {
                this.setState({
                  showModal: false
                });
              }}
              calculator={this.state.calculator}
              carData={this.state.carDataBase}
            />
          )}
        </div>
      );
    }
  }
}

CarPage.contextType = ThemeContext;

export default CarPage;
